<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 text-center text-sm-left mb-0">
                <h3 class="page-title">Supercharge your affiliate links</h3>
            </div>
        </div>
        <!-- Second Row of Posts -->
        <d-row>
            <d-col lg="12">
                <d-card>
                    <d-card-header class="border-bottom">
                        <d-row class="d-flex justify-content-center">
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-domain' }">1. Add website</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-network' }">2. Connect networks</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-intergration' }">3. Connect integrations</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'snippet' }">4. Place Ivanhoe.io tag</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'affiliate-link' }"><u>5. Choose direct or cloaked links</u></d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text pl-0 pr-0 d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">6. Ready to start</h6>
                            </d-col>
                        </d-row>
                        <d-progress :value="percent" :max="100" />
                    </d-card-header>

                    <d-col class="mt-5 mb-3">
                        <d-row class="d-flex justify-content-center">
                            <d-col class="ml-3 mr-3 mt-4" lg="5" md="11" sm="11">
                                <d-card class="h-100">
                                    <d-card-header></d-card-header>
                                    <d-card-body>
                                        <d-col>
                                            <h5 class="text-center font-weight-bold">Direct Affiliate links</h5>
                                            <p class="text-center">Choose this type of linking when you use direct affiliate links. In this case you can just enter IVANHOE as a sub-id and you're ready to go!</p>
                                        </d-col>
                                        <d-col class="d-flex justify-content-center">
                                            <d-link tag="button" :to="{ name: 'sub-ids' }" class="btn btn-success">I use Direct Affiliate links</d-link>
                                        </d-col>
                                    </d-card-body>
                                </d-card>
                            </d-col>
                            <d-col class="ml-3 mr-3 mt-4" lg="5" md="11" sm="11">
                                <d-card class="h-100">
                                    <div class="card-header affiliate">
                                    </div>
                                    <d-card-body>
                                        <h5 class="text-center font-weight-bold">Cloaked links</h5>
                                        <p class="text-center">When you use cloaked links you need to use our cloaked link API or one of the supported cloaked links plugins to start working with Ivanhoe.io.</p>
                                        <d-col class="d-flex justify-content-center">
                                            <d-link tag="button" :to="{ name: 'cloaked', params: { id: websiteId } }" class="btn btn-success">I use cloaked links</d-link>
                                        </d-col>
                                    </d-card-body>
                                </d-card>
                            </d-col>
                        </d-row>
                    </d-col>

                    <d-card-footer>
                        <d-row>
                            <d-col class="d-flex justify-content-start">
                                <d-link tag="button" :to="{ name: 'snippet', params: { id: websiteId } }" class="btn btn-secondary">Previous step</d-link>
                            </d-col>
                        </d-row>
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
export default {
    data() {
        return {
            websiteId: this.$route.params.id,
            percent: 75,
        };
    },
};
</script>
